import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const fetchUserLineup = async (
  leagueId,
  eventId,
  userId,
  getAccessTokenSilently
) => {
  const token = await getAccessTokenSilently();
  const apiUrl = process.env.REACT_APP_API_URL;

  const { data } = await axios.get(
    `${apiUrl}/api/lineup/${leagueId}/${eventId}/${userId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const useFetchUserEventLineup = (
  leagueId,
  eventId,
  userId,
  isBeforeEventStart
) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery(
    ["userLineup", leagueId, eventId, userId],
    () => fetchUserLineup(leagueId, eventId, userId, getAccessTokenSilently),
    {
      enabled: !!leagueId && !!eventId && !!userId && isBeforeEventStart,
    }
  );
};
